const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/venues/$id.rental.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
// import { getNearestVersionDate } from '@common';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/venues/$id/rental')({
  beforeLoad: async ({
    context: {
      rentalVersionDates
    },
    params,
    matches
  }) => {
    const lastMatch = matches[matches.length - 1];
    if (!lastMatch.id.endsWith(`/venues/${params.id}/rental`)) return;

    // const latestVersion = getNearestVersionDate(rentalVersionDates); // We leave this uncommented instead of removing it for the case that the customer wants to use the nearest version date in the future.
    const latestVersion = rentalVersionDates[rentalVersionDates.length - 1];
    if (!latestVersion) {
      redirect({
        to: '/venues/$id/general',
        params: {
          id: params.id
        },
        throw: true,
        replace: true
      });
    } else {
      redirect({
        to: '/venues/$id/rental/$version',
        params: {
          id: params.id,
          version: latestVersion
        },
        throw: true,
        replace: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});